export const userTypesMap: any = {
  Deliverer: 'Deliverer',
  Organizer: 'Organizer',
  Volunteer: 'Volunteer',
  Artist: 'Artist',
};
